import { render, staticRenderFns } from "./button-dropdown.vue?vue&type=template&id=fe2740b6&"
import script from "./button-dropdown.vue?vue&type=script&lang=js&"
export * from "./button-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports